import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border shadow-lg border-red-600 bg-red-100 dark:bg-red-900 dark:border-red-900 rounded mb-6 p-4 text-red-600 dark:text-dark-text",
  style: {"border-radius":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JudgeDetailResult = _resolveComponent("JudgeDetailResult")!
  const _component_JudgeDetailTestCase = _resolveComponent("JudgeDetailTestCase")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-5 box-border h-full overflow-y-scroll", {
      'custom-scrollbar': _ctx.isLightMode(),
      'custom-scrollbar-dark': !_ctx.isLightMode()
    }])
  }, [
    _createVNode(_component_JudgeDetailResult, { judgeLoading: _ctx.isJudgeLoading }, null, 8, ["judgeLoading"]),
    (!_ctx.isJudgeLoading && _ctx.judgeDetail && (_ctx.judgeDetail.compileError || _ctx.judgeDetail.runtimeError))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.judgeDetail ? _ctx.judgeDetail.compileError : '') + " " + _toDisplayString(_ctx.judgeDetail ? _ctx.judgeDetail.runtimeError : ''), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_JudgeDetailTestCase)
  ], 2))
}